import React from "react";
import { Modal } from "antd";
import { IconExclamation } from "../components/Layout/Icons";

const { confirm } = Modal;
const AntdConfirm = ({
  title = "Are you sure?",
  content = "You will not be able to undo this action",
  onOk,
  onCancel = () => console.log("CancelDefault"),
}) =>
  confirm({
    title,
    icon: <IconExclamation className="text-orange" />,
    content,
    onOk() {
      onOk();
      console.log("OK");
    },
    onCancel() {
      onCancel();
      console.log("Cancel");
    },
  });

export default AntdConfirm;
